__turbopack_context__.v({
  "basic-space": "GuideDescription-module-scss-module__CAUa-G__basic-space",
  "button_area": "GuideDescription-module-scss-module__CAUa-G__button_area",
  "description": "GuideDescription-module-scss-module__CAUa-G__description",
  "description-subtitle": "GuideDescription-module-scss-module__CAUa-G__description-subtitle",
  "guide": "GuideDescription-module-scss-module__CAUa-G__guide",
  "icon-space": "GuideDescription-module-scss-module__CAUa-G__icon-space",
  "icon_area": "GuideDescription-module-scss-module__CAUa-G__icon_area",
  "title-large": "GuideDescription-module-scss-module__CAUa-G__title-large",
  "title-medium": "GuideDescription-module-scss-module__CAUa-G__title-medium",
});
